import api from "../api-backend";

class AssignaturaService {

    getAssignatures = async (page, size, query, sort) => {
        const response = await api.get(`/engine/assignatures?query=${query}&rows=${size}&start=${page}&sort=${sort}`)
        return {
            'assignatures': response.data.response.docs,
            'facetes': response.data.facet_counts.facet_fields,
            'total': response.data.response.numFound
        }
    }

    getAssignatura = async (id) => {
        const response = await api.get(`/engine/${id}`)
        return {
            'assignatura': response.data.response.docs[0],
        }
    }

    getDocencia = async (id) => {
        const response = await api.get(`/engine/assignatura/docencia/${id}`)
        return {
            'docencia': response.data.response.docs,
        }
    }

    getGuiaDocent = async (codi, curs, idioma) => {
        const response = await api.get(`/guiesdocents/${codi}/${curs}/${idioma}`)
        return response.data
    }

    getDisponibilitatGuies = async (codi) => {
        const response = await api.get(`/guiesdocents/disponibilitat/${codi}`)
        return response.data
    }

    getBibliografia = async (codi, curs) => {
        const response = await api.get(`/bibliografia/${codi}/${curs}`)
        return response.data
    }

    getDisponibilitatBibliografia = async (codi) => {
        const response = await api.get(`/bibliografia/disponibilitat/${codi}`)
        return response.data
    }
}

export default new AssignaturaService()
